import React, { useCallback, useEffect, useRef, useState } from "react";
import i18next, { DEFAULT_LANGUAGE, LANGUAGES } from "../../base/i18n/i18next";
import LANGUAGE_LIST from "../../../../lang/languages.json";
import { useTranslation } from "react-i18next";
const Header = ({ onJoin }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const containerRef = useRef(null);
    const burgerRef = useRef(null);
    const { t } = useTranslation();
    const body = document.querySelector("body");
    const language = i18next.language || DEFAULT_LANGUAGE;
    const languageItems = LANGUAGES?.filter((language) => language === "en").map((language) => {
        return {
            value: language,
            label: t(`languages:${language}`),
        };
    });
    const onLanguageSelected = useCallback((e) => {
        i18next.changeLanguage(e);
    }, [language]);
    const handleToggle = (e) => {
        setIsActive((prev) => !prev);
        e?.stopPropagation();
    };
    const handleClickOutside = (e) => {
        if (containerRef?.current &&
            !containerRef?.current?.contains(e?.target)) {
            setIsActive(false);
        }
    };
    useEffect(() => {
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    useEffect(() => {
        if (isMenuOpen) {
            body?.classList.add("locked");
        }
        else {
            body?.classList.remove("locked");
        }
    }, [isMenuOpen]);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 991.98) {
                setIsMenuOpen(false);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return (React.createElement("header", { className: "header" },
        React.createElement("nav", { className: "nav" },
            React.createElement("div", { className: "container" },
                React.createElement("div", { className: "navbar" },
                    React.createElement("div", { className: "logo" },
                        React.createElement("a", { className: "logo__link", href: "#" },
                            React.createElement("img", { className: "logo__img", src: "../../../../images/welcome/logo.svg", alt: "logo icon" }))),
                    React.createElement("ul", { className: `menu ${isMenuOpen ? "active" : ""}` },
                        React.createElement("li", { className: "menu__item" },
                            React.createElement("a", { href: "#about", className: "menu__item-link", "data-scroll": true, onClick: () => setIsMenuOpen(false) }, t("welcomepage.header.about"))),
                        React.createElement("li", { className: "menu__item" },
                            React.createElement("a", { href: "#support", className: "menu__item-link", "data-scroll": true, onClick: () => setIsMenuOpen(false) }, t("welcomepage.header.supportProject"))),
                        React.createElement("li", { className: "menu__item" },
                            React.createElement("a", { href: "#cooperate", className: "menu__item-link", "data-scroll": true, onClick: () => setIsMenuOpen(false) }, t("welcomepage.header.cooperation")))),
                    React.createElement("div", { className: "nav__others" },
                        React.createElement("div", { className: `nav__language ${isActive ? "active" : ""}`, ref: containerRef },
                            React.createElement("div", { className: "nav__language-selected", onClick: handleToggle },
                                React.createElement("div", { className: "nav__language-text" }, t(LANGUAGE_LIST[language?.toString()])),
                                React.createElement("img", { className: "nav__language-arrow", src: "../../../../images/welcome/icons/arrow-down.svg", alt: "arrow" })),
                            React.createElement("ul", { className: "nav__language-list" }, languageItems.map((item) => (React.createElement("li", { key: item?.value, className: `nav__language-item ${t(language) === t(item?.value)
                                    ? "active"
                                    : ""}` },
                                React.createElement("button", { className: "nav__language-link", onClick: () => {
                                        onLanguageSelected(item?.value);
                                        setIsActive(false);
                                    } }, t(LANGUAGE_LIST[item?.value?.toString()]))))))),
                        React.createElement("button", { className: "nav__link btn", onClick: onJoin }, t("welcomepage.makeACall"))),
                    React.createElement("div", { ref: burgerRef, className: `burger ${isMenuOpen ? "active-burger" : ""}`, onClick: () => setIsMenuOpen((prev) => !prev) },
                        React.createElement("span", null),
                        React.createElement("span", null)))))));
};
export default Header;
